// Importing the uniqid package and the projects array from the portfolio file
import uniqid from 'uniqid'
import { projects } from '../../portfolio'
// Importing the ProjectContainer component and the Projects CSS file
import ProjectContainer from '../ProjectContainer/ProjectContainer'
import './Projects.css'

// Defining the Projects component
const Projects = () => {
  // If there are no projects in the array, return null and don't render the component
  if (!projects.length) return null

  // Otherwise, render the component
  return (
    <section id='projects' className='section projects'>
      <h2 className='section__title'>Portfolio</h2>

      <div className='projects__grid'>
        {projects.map((project) => (
          // eslint-disable-next-line react/jsx-no-target-blank
          <a href={`${projects.URL}`}>
          <ProjectContainer key={uniqid()} project={project} backgroundImage={project.backgroundImage} />
          </a>
        ))}
        
      </div>
    </section>
  )
}

export default Projects
